import axios from '@/plugins/axios'


export default {
    state: {
        profilesList: []
    },
    mutations: {
        setProfilesList(state, item) {
            state.profilesList = item
        },
        getLoginSetting(state, item) {
            state.login = item
        }
    },
    actions: {
        async Autorisation({ commit }, data) {
            try {
                axios
                    .post(
                        "http://core.memo.az/account/login", data
                    )
                    .then((res) => {
                        if (res.status == "fail") {
                            localStorage.removeItem("hash");
                            toastr.warning("Введеный логин или пароль не верен");
                            return;
                          }
                          localStorage.hash = res.hash;
                        //   this.disableSend = false;
                            router.push("/");
                        return res
                    })
                    .finally(() => { 
                        commit("stopLoader");
                    });
            } catch (e) {
                throw e
            }
        },
        GetProfileNames({ commit }) {
            try {
                return axios
                    .post("http://core.memo.az/mainwindow/GetProfileNames")
                    .then((res) => {
                        console.log(res);
                        if (res) {
                            commit('setProfilesList', res.data)
                        }
                        return res.data
                    })
            } catch (e) {
                throw e
            }
        },
    },
    getters: {
        profilesList(state) {
            return state.profilesList
        }
    }
}